var modules_5e1660a2 = {"container":"_of2wf7","size-2":"_1t2aowg","size-4":"_1wosh6","size-8":"_1l49u15","size-12":"_7qppfb","size-16":"_1ycz8ld","size-20":"_1jlf458","size-24":"_1foztdp","size-28":"_6cqm41","size-32":"_1bipc4x","size-36":"_1gmmhlx","size-40":"_1p64dcs"};
import "../../../assets/BrCNBX-A.css";

export { modules_5e1660a2 as default };
//# sourceMappingURL=Divider.module.less.js.map
